import Link from "@/modules/LinkPedido/Index.vue";

export default [
  {
    path: "/pedido/:uuid",
    component: Link,
    meta: { title: "Pedido Digital" },
  },
];
